import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
// COMMON
import Navbar from "./Common/navbar/Navbar";
import Footer from "./Common/footer/Footer";
import FloatingWidgets from "./Common/floatingwidgets/FloatingWidgets";
// HOMEPAGE
import HomePage from "./Pages/homepage/HomePage.jsx";
import CurtainRaiserVideoPage from "./Components/home/homevideo/CurtainRaiserVideoPage.jsx";
import VoiceOfBBVideoPage from "./Components/home/homevideo/VoiceOfBBVideoPage.jsx";
// ABOUTUSPAGE
import AboutUs from "./Pages/aboutuspage/AboutUs.jsx";
// DirectorsMessagePAGE
import DirectorsMessage from "./Pages/directorsmessage/DirectorsMessage.jsx";
// Exhibition
import Exhibition from "./Pages/exhibition/Exhibition.jsx";
// EDITIONS
import Edition from "./Pages/Editions/Edition.jsx";
// CONFERENCES
import Conferences from "./Pages/conferencespage/Conferences.jsx";
// WhyVisitPage
import WhyVisit from "./Pages/whyvisitpage/WhyVisit.jsx";
// NEWSLETTER
import NewsLetter from "./Pages/newsletterpage/NewsLetter.jsx";
import Blogs from "./Pages/newsletterpage/blogs/Blogs.jsx";
import SocialWallofFame from "./Pages/newsletterpage/social_wall_of_fame/SocialWallofFame.jsx";
import NewsArticles from "./Pages/newsletterpage/newsarticles/NewsArticles.jsx";
import DigitalMediaCoverage from "./Pages/newsletterpage/digital_media_coverage/DigitalMediaCoverage.jsx";
// GALLERYPAGE
import GalleryPage from "./Pages/gallerypage/GalleryPage.jsx";
import VoiceOfStakeholders from "./Components/gallery/gallery_voice_of_bb/VoiceOfStakeholders.jsx";
import VoiceOfIndustryLeaders from "./Components/gallery/gallery_voice_of_bb/VoiceOfIndustryLeaders.jsx";
import NationalPromotionsMedia from "./Components/gallery/gallery_national_promotions/NationalPromotionsMedia.jsx";
import InternationalPromotionsMedia from "./Components/gallery/gallery_international_promotions/InternationalPromotionsMedia.jsx";
// REGISTRATION
import RegistrationPage from "./Pages/registrationpage/RegistrationPage.jsx";
import DomesticVisitors from "./Pages/registrationpage/domestic_visitors/DomesticVisitors.jsx";
import InternationalVisitors from "./Pages/registrationpage/international_visitors/InternationalVisitors.jsx";
import ExhibitorInquiry from "./Pages/registrationpage/exhibitor_inquiry/ExhibitorInquiry.jsx";
import SubmitManufacturer from "./Pages/registrationpage/submit_manufacturer/submit_manufacturer.js";
// CONTACTUS
import ContactUs from "./Pages/contactuspage/ContactUs.jsx";
// ERROR PAGE
import Error from "./Pages/errorpage/Error.jsx";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const elementId = hash.replace("#", "");
      setTimeout(() => {
        const el =
          document.getElementById(elementId) ||
          document.getElementById(elementId.replace(/_/g, "-")) ||
          document.getElementById(elementId.replace(/-/g, "_"));
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 150);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

function App() {
  return (
    <BrowserRouter
      basename=""
      future={{ v7_startTransition: true }}
    >
      <ScrollToTop />
      <Navbar />
      <Routes>
        {/* HOMEPAGE */}
        <Route path="/" element={<HomePage />} />
        <Route path="/CurtainRaiser" element={<CurtainRaiserVideoPage />} />
        <Route path="/VoiceOfBharatBuildcon" element={<VoiceOfBBVideoPage />} />

        {/* ABOUTUS-PAGE */}
        <Route path="/aboutus" element={<AboutUs />} />

        {/* DirectorsMessagePAGE */}
        <Route path="/directorsmessage" element={<DirectorsMessage />} />

        {/* EXHIBITION-PAGE */}
        <Route path="/exhibition" element={<Exhibition />} />

        {/* EDITIONS */}
        <Route path="/edition" element={<Edition />} />
        <Route path="/edition/:id" element={<Edition />} />

        {/* CONFERENCES */}
        <Route path="/conferences" element={<Conferences />} />

        {/* WhyVisitPage */}
        <Route path="/whyvisit" element={<WhyVisit />} />

        {/* NEWSLETTER-PAGE */}
        <Route path="/newsletter" element={<NewsLetter />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/socialwalloffame" element={<SocialWallofFame />} />

        <Route path="/newsarticles" element={<NewsArticles />} />
        <Route
          path="/digitalmediacoverage"
          element={<DigitalMediaCoverage />}
        />

        {/* GALLERY-PAGE */}
        <Route path="/gallery" element={<GalleryPage />} />

        <Route path="/voiceofstakeholder" element={<VoiceOfStakeholders />} />
        <Route
          path="/voiceofindustryleaders"
          element={<VoiceOfIndustryLeaders />}
        />
        <Route
          path="/nationalpromotionsmedia"
          element={<NationalPromotionsMedia />}
        />
        <Route
          path="/nationalpromotionsmedia/:id"
          element={<NationalPromotionsMedia />}
        />
        <Route
          path="/internationalpromotionsmedia"
          element={<InternationalPromotionsMedia />}
        />
        <Route
          path="/internationalpromotionsmedia/:id"
          element={<InternationalPromotionsMedia />}
        />
        {/* REGISTRATION-PAGE */}
        <Route path="/registration" element={<RegistrationPage />} />
        <Route path="/domesticvisitors" element={<DomesticVisitors />} />
        <Route
          path="/internationalvisitors"
          element={<InternationalVisitors />}
        />
        <Route path="/exhibitors" element={<ExhibitorInquiry />} />
        <Route
          path="/manufacturerexhibitors"
          element={<SubmitManufacturer />}
        />

        {/* CONTACTUS-PAGE */}
        <Route path="/contactus" element={<ContactUs />} />

        {/* 404 ERROR PAGE */}
        <Route path="*" element={<Error />} />
      </Routes>
      <Footer />
      <FloatingWidgets />
    </BrowserRouter>
  );
}

export default App;
